import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/@services/common.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import {
  CommonResponseRecords,
  CommonResponseResult,
} from 'src/models/commomnModel.model';
import { Investor } from 'src/models/investment.model';
import { Vendor } from 'src/models/vendor.model';
import { responseMessageStatus, ResponseStatus } from '../../enum';
interface siteDetails {
  Name: string;
  Profile: string;
  NonAlcStatus: boolean;
}
@Component({
  selector: 'app-new-investor-vendor',
  templateUrl: './new-investor-vendor.component.html',
  styleUrls: ['./new-investor-vendor.component.scss'],
  standalone: false,
})
export class NewInvestorVendorComponent implements OnInit {
  //#region properties
  isDeletingInvestor: boolean = false;
  canAddInvestor: boolean = false;
  isVisibleInvestorDrawer: boolean = false;
  isVisibleVendorDrawer: boolean = false;
  isOpenDropdown: boolean = false;
  @Input() isAddEditPaymentScreen: boolean = false;
  @Output() newCreatedInvestor = new EventEmitter();
  @Output() newCreatedVendor = new EventEmitter();
  @Output() showVendorForm = new EventEmitter();
  isLoading: boolean = false;
  isDataLoaded: boolean = false;
  canAddVendor: boolean = false;
  inputValue?: string;
  searchText: string = '';
  oldSearchText: string = '';
  timer = null;
  @Input() userType: string;
  siteId: string;
  investorsDBList: Investor[] = [];
  vendorsDBList: Vendor[] = [];
  currentAddingInvestor: Investor;
  currentAddingVendor: Investor;
  isDeletingVendor: boolean = false;
  siteDetails: siteDetails;
  //#endregion

  //constructor
  constructor(
    private _iS: InnerPagesService,
    public _cS: CommonService,
    private route: ActivatedRoute
  ) {}

  //#region functions
  ngOnInit(): void {
    //get site id for url
    this.siteId = this.route.snapshot.paramMap.get('siteId');
    this.canAddVendor = this._iS.canAccessVendors().canAddVendor;
    // get permission details of current user role of Investors
    this.canAddInvestor = this._iS.canAccessInvestors().canAddInvestor;
    this._cS.agencySiteDetails.subscribe((res: siteDetails) => {
      if (res) {
        this.siteDetails = res;
      }
    });
  }

  onDropdownOpen(isOpen: boolean): void {
    this.isOpenDropdown = isOpen;
  }
  //add new investor from database dropdown list
  addInvestorToList(investor: Investor) {
    const index = this.investorsDBList.findIndex(
      (x: Investor) => x._id == investor._id
    );
    this.investorsDBList[index].isAlreadyAdded = true;
    this.currentAddingInvestor = investor;
    this.isDeletingInvestor = true;
    const formData = new FormData();
    formData.set('investorId', investor._id);
    formData.set('siteId', this.siteId);
    this._iS
      .AddInvestorFromDB(formData)
      .subscribe((response: CommonResponseRecords<Investor>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isDeletingInvestor = false;
          this.newCreatedInvestor.emit({
            hide: this.isVisibleInvestorDrawer,
            data: response.result,
          });
          const index = this.investorsDBList.findIndex(
            (x: Investor) => x._id == investor._id
          );
          this.investorsDBList[index].isAlreadyAdded = true;
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          const index = this.investorsDBList.findIndex(
            (x: Investor) => x._id == investor._id
          );
          this.investorsDBList[index].isAlreadyAdded = false;
          this.isDeletingInvestor = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }

  //search supplier
  searchInvestor(event: any) {
    this.searchText = event;
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.getAllDBInvestors();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.getAllDBInvestors();
        }
      }
    }
  }
  //get investors from db in dropdown
  getAllDBInvestors() {
    this.isLoading = true;
    this._iS
      .searchInDatabaseInvestor(this.searchText.trim(), this.siteId)
      .subscribe((response: CommonResponseResult<Vendor>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.investorsDBList = response.result;
          this.isLoading = false;
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
          this.isLoading = false;
        }
      });
  }
  //hide modal of adding/editing role
  hideInvestorDrawer(event: { data: Investor }) {
    this.isVisibleInvestorDrawer = false;
    this.newCreatedInvestor.emit({
      hide: this.isVisibleInvestorDrawer,
      data: event ? event.data : null,
    });
  }

  //get all vendors in dropdown from db
  getAllDBVendors() {
    this.isLoading = true;
    this._iS
      .searchInDatabase(this.searchText.trim(), this.siteId)
      .subscribe((response: CommonResponseResult<Vendor>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.vendorsDBList = response.result;
          this.isLoading = false;
        } else {
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
          this.isLoading = false;
        }
      });
  }
  //add new vendor from database dropdown list
  addVendorToList(vendor: Vendor) {
    this.currentAddingVendor = vendor;
    this.isDeletingVendor = true;
    const formData = new FormData();
    formData.set('vendorId', vendor._id);
    formData.set('siteId', this.siteId);
    this._iS
      .AddVendorFromDB(formData)
      .subscribe((response: CommonResponseRecords<Vendor>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isDeletingVendor = false;
          this.newCreatedVendor.emit({
            hide: this.isVisibleVendorDrawer,
            data: response.result,
          });
          const index = this.vendorsDBList.findIndex(
            (x: Vendor) => x._id == vendor._id
          );
          this.vendorsDBList[index].IsAlreadyAdded = true;
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
        } else {
          this.isDeletingVendor = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  //hide modal of adding/editing role
  hideVendorDrawer(event: { data: Vendor }) {
    this.isVisibleVendorDrawer = false;
    this.newCreatedVendor.emit({
      hide: this.isVisibleVendorDrawer,
      data: event ? event.data : null,
    });
  }
  showInvestorModal(){
    this.isOpenDropdown = false;    
    if(!this.isAddEditPaymentScreen){
      this.isVisibleInvestorDrawer = true;
    }else{
      this.showVendorForm.emit(true);
    }

  }
  //to show modal
  showVendorModal(): void {
    this.isOpenDropdown = false;
    if(!this.isAddEditPaymentScreen){
      this.isVisibleVendorDrawer = true;
    }else{
      this.showVendorForm.emit(true);
    }
    
  }
  //search supplier
  searchVendor(event: any) {   
    this.searchText = event;
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.getAllDBVendors();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.oldSearchText = '';
          this.getAllDBVendors();
        }
      }
    }

    // //front side search from list of vendors based on search text entered check in vendorDisplayName and companyName
    // if (this.oldSearchText != this.searchText) {
    //   if (this.searchText) {
    //     this.vendorsDBList = this.vendorsDBList.filter((x: Vendor) =>
    //       x.VendorDisplayName.toLowerCase().includes(this.searchText.toLowerCase())
    //     );
    //   } else {
    //     this.getAllDBVendors();
    //   }
    // }
  }
  //#endregion
}
